{"schemaVersion":1,"release":{"version":"1.1.13","build":175,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.13-175.dmg","sha256":"c9dbc2446828a172b9ba5c01a797ddf133756f23a5a53d44a0bd4eef446b8ac7","size":286997665}}
